// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlignLeftOutlinedSvg from "@fishx/icons-svg/es/asn/AlignLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var AlignLeftOutlined = function AlignLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlignLeftOutlinedSvg
  }));
};

AlignLeftOutlined.displayName = 'AlignLeftOutlined';
export default React.forwardRef(AlignLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AlignLeftOutlined.js
// module id = 1955
// module chunks = 0